export type DuTypeModel = {
  ContainerType: string,
  ContainerName: string,
  Description: string,
}

export const initialValueOfDuTypeModel: DuTypeModel = {
  ContainerType: "",
  ContainerName: "",
  Description: "",
}